import { render, staticRenderFns } from "./BasicStep.vue?vue&type=template&id=4cbbe166&"
import script from "./BasicStep.vue?vue&type=script&lang=ts&"
export * from "./BasicStep.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/actions-runner/_work/mfe-cfm/mfe-cfm/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cbbe166')) {
      api.createRecord('4cbbe166', component.options)
    } else {
      api.reload('4cbbe166', component.options)
    }
    module.hot.accept("./BasicStep.vue?vue&type=template&id=4cbbe166&", function () {
      api.rerender('4cbbe166', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/wizard/BasicStep.vue"
export default component.exports